const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'etype_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_ETYPES':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_ETYPES':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_ETYPES':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_ETYPES':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_ETYPE':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.etype_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/etypes.js